import { render, staticRenderFns } from "./edit-purchase-draft.vue?vue&type=template&id=4116dca4&"
import script from "./edit-purchase-draft.vue?vue&type=script&lang=js&"
export * from "./edit-purchase-draft.vue?vue&type=script&lang=js&"
import style0 from "./edit-purchase-draft.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports